module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec05_pc_b76e22892f12e441dba8fdee1203d04e.jpg";